import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";
import Logo from "@/components/Logo";
import api from "@/lib/api";

export default function UnsubscribePage() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/api/unsubscribe", { email });
            setDone(true);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Não foi possível concluir agora. Tente novamente.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex min-h-[80vh] items-center justify-center bg-forest-deep px-4" data-testid="unsubscribe-page">
            <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.06] p-8 text-center backdrop-blur-xl">
                <div className="flex justify-center">
                    <Logo />
                </div>

                {done ? (
                    <div className="mt-6" data-testid="unsubscribe-success">
                        <CheckCircle2 className="mx-auto h-9 w-9 text-emerald-400" />
                        <h1 className="mt-4 font-serif text-2xl font-semibold text-white">Tudo certo!</h1>
                        <p className="mt-2 text-xs leading-relaxed text-stone-400">
                            Seu e-mail foi descadastrado. Você não receberá mais nossas comunicações de ofertas.
                        </p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <h1 className="mt-6 font-serif text-2xl font-semibold text-white">Descadastrar e-mail</h1>
                        <p className="mt-2 text-xs leading-relaxed text-stone-400">
                            Informe seu e-mail para não receber mais ofertas da Destino Resorts. Seus dados de cotações já solicitadas são preservados.
                        </p>

                        <label className="mt-7 block text-left text-[11px] font-semibold uppercase tracking-[0.16em] text-stone-400" htmlFor="unsub-email">
                            Seu e-mail
                        </label>
                        <input
                            id="unsub-email"
                            data-testid="unsubscribe-email-input"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-sm text-white outline-none transition-colors placeholder:text-stone-500 focus:border-gold"
                            placeholder="voce@email.com"
                            autoComplete="email"
                        />

                        <button
                            type="submit"
                            data-testid="unsubscribe-submit-btn"
                            disabled={busy}
                            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-semibold text-forest-deep transition-all duration-200 hover:bg-sun disabled:opacity-60 active:scale-[0.98]"
                        >
                            <Mail className="h-4 w-4" />
                            {busy ? "Processando..." : "Confirmar descadastro"}
                        </button>
                    </form>
                )}

                <Link to="/" data-testid="unsubscribe-back-home" className="mt-6 inline-block text-xs font-medium text-stone-400 transition-colors hover:text-gold">
                    Voltar para a página inicial
                </Link>
            </div>
        </div>
    );
}
